import { render, staticRenderFns } from "./ScheduleLoyaltyDiscountList.vue?vue&type=template&id=5fb60b3b&scoped=true"
import script from "./ScheduleLoyaltyDiscountList.vue?vue&type=script&lang=js"
export * from "./ScheduleLoyaltyDiscountList.vue?vue&type=script&lang=js"
import style0 from "./ScheduleLoyaltyDiscountList.vue?vue&type=style&index=0&id=5fb60b3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb60b3b",
  null
  
)

export default component.exports